module.exports = __webpack_public_path__ + "img/c3.d77a0e65.png";